import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import SegmentsAPI from '../../api/segments';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSegments(_state) {
    return _state.records;
  },
  getSegmentById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_SEGMENTS_UI_FLAG, { isFetching: true });
    try {
      const response = await SegmentsAPI.get();
      const segments = response.data?.payload || response.data || [];
      commit(types.SET_SEGMENTS, segments);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SEGMENTS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, segmentData) => {
    commit(types.SET_SEGMENTS_UI_FLAG, { isCreating: true });
    try {
      const response = await SegmentsAPI.create({ segment: segmentData });
      const segment = response.data?.payload || response.data;
      commit(types.ADD_SEGMENT, segment);
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_SEGMENTS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...segmentData }) => {
    commit(types.SET_SEGMENTS_UI_FLAG, { isUpdating: true });
    try {
      const response = await SegmentsAPI.update(id, { segment: segmentData });
      const segment = response.data?.payload || response.data;
      commit(types.UPDATE_SEGMENT, segment);
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_SEGMENTS_UI_FLAG, { isUpdating: false });
    }
  },

  combine: async ({ commit }, { operation, segmentIds, name, description }) => {
    const response = await SegmentsAPI.combine(
      operation,
      segmentIds,
      name,
      description
    );
    const segment = response.data?.payload || response.data;
    commit(types.ADD_SEGMENT, segment);
    return segment;
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_SEGMENTS_UI_FLAG, { isDeleting: true });
    try {
      await SegmentsAPI.delete(id);
      commit(types.DELETE_SEGMENT, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SEGMENTS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_SEGMENTS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SEGMENTS](_state, data) {
    MutationHelpers.set(_state, data);
  },
  [types.ADD_SEGMENT](_state, data) {
    MutationHelpers.create(_state, data);
  },
  [types.UPDATE_SEGMENT](_state, data) {
    MutationHelpers.update(_state, data);
  },
  [types.DELETE_SEGMENT](_state, data) {
    MutationHelpers.destroy(_state, data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
